import "./src/global.scss";

import React from "react";
import {
  GlobalLocalizationProvider,
  PageLocalizationProvider,
} from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { LocationProvider } from "@reach/router";

import { OldCartProvider } from "./src/contexts/oldCart/OldCartProvider";

import { ServicesContextProvider } from "@sbi-international/boutik.gatsby.plugin.services/dist/src/contexts/ServicesContextProvider";
import { MagentoAPIProvider } from "@sbi-international/boutik.gatsby.plugin.services/dist/src/contexts/MagentoAPIProvider";

import { MagentoStoreProvider } from "@sbi-international/boutik.gatsby.plugin.services/dist/src/contexts/MagentoStoreProvider";
import { MagentoCustomerProvider } from "@sbi-international/boutik.gatsby.plugin.services/dist/src/contexts/MagentoCustomerProvider";

import { FeedbackProvider } from "./src/contexts/feedback/FeedbackProvider";
import { FeedbackProviderWrapper } from "./src/contexts/feedback/FeedbackProviderWrapper";

import { CartContextProvider } from "@sbi-international/boutik.gatsby.plugin.checkout";

import { cookieConsentConfig } from "./cookieConsentConfig";
import { CookiesConsentProvider } from "@sbi-international/boutik.package.cookie.consent";

export const wrapRootElement = ({ element }, { magentoBackend }) => {
  const isBrowser = typeof window !== "undefined";
  const apiBase = typeof window !== "undefined" ? window.location?.origin : null;

  //const magentoGraphqlService = new MagentoGraphqlService({
  //  apiBase: apiBase || magentoBackend,
  //})

  return (
    <GlobalLocalizationProvider>
      <LocationProvider>
        <FeedbackProvider>
          <MagentoAPIProvider magentoUrl={apiBase || magentoBackend}>
            <ServicesContextProvider magentoUrl={apiBase || magentoBackend}>
              <FeedbackProviderWrapper>
                {isBrowser ? (
                  <CookiesConsentProvider config={cookieConsentConfig}>{element}</CookiesConsentProvider>
                ) : (
                  element
                )}
              </FeedbackProviderWrapper>
            </ServicesContextProvider>
          </MagentoAPIProvider>
        </FeedbackProvider>
      </LocationProvider>
    </GlobalLocalizationProvider>
  );
};

/*
<GlobalLocalizationProvider>
</GlobalLocalizationProvider>
*/
export const wrapPageElement = ({ element, props: { pageContext } }) => {
  return (    
      <PageLocalizationProvider pageContext={pageContext}>
        <MagentoStoreProvider>
          <MagentoCustomerProvider>
            <OldCartProvider>
              <CartContextProvider>{element}</CartContextProvider>
            </OldCartProvider>
          </MagentoCustomerProvider>
        </MagentoStoreProvider>
      </PageLocalizationProvider>   
  );
};
